<template>
  <b-row
    v-if="method === 1 || method === 2 || method === 3"
    md="12"
  >
    <b-col>
      <b-form-group
        label="Main Menu Name (Your Product Name)"
        label-for="menu-name"
      >
        <validation-provider
          #default="{ errors }"
          name="menu-name"
          rules="required|max16"
        >
          <b-form-input
            id="menu-name"
            v-model="content.sub_menu[i].name"
            placeholder="Write a short script"
            rows="3"
            :state="errors.length > 0 ? false:null"
            @keyup="countdownMenu(i)"
            @input="countdownMenu(i)"
          />
          <small class="text-danger">{{ errors[0] }}</small>
          <b-form-text
            :ref="`menuName-${i}`"
            class="small"
          >
            Remaining Char: {{ remainingMenuCount[i] }} Char</b-form-text>
        </validation-provider>
      </b-form-group>
    </b-col>
    <!-- <b-col
      v-if="method === 2"
      md="6"
    >
      <b-form-group
        :label="setLabel('Action Link', i)"
        :label-for="setIdName('action-link', i)"
      >
        <validation-provider
          #default="{ errors }"
          name="action link 1"
          rules="required"
        >
          <b-form-input
            :id="setIdName('action-link', i)"
            v-model="content.sub_menu[i].action_link"
            placeholder="domain.com/xxxxx"
            rows="3"
            :state="errors.length > 0 ? false:null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col> -->
    <b-col
      v-if="method === 3"
      md="4"
    >
      <b-form-group
        :label="setLabel('Main Menu Product Registry Key', i)"
        :label-for="setIdName('product-registry-key', i)"
      >
        <validation-provider
          #default="{ errors }"
          name="product-registry-key"
          rules="required"
        >
          <b-form-input
            :id="setIdName('product-registry-key', i)"
            v-model="content.sub_menu[i].product_registry_key"
            placeholder="Type your product registry key"
            rows="3"
            :state="errors.length > 0 ? false:null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="method === 3"
      md="2"
    >
      <b-form-group
        :label="setLabel('Main Menu Shortcode', i)"
        :label-for="setIdName('shortcode', i)"
      >
        <validation-provider
          #default="{ errors }"
          name="shortcode"
          rules="required|regex:^([0-9]+)$"
        >
          <b-form-input
            :id="setIdName('shortcode', i)"
            v-model="content.sub_menu[i].shortcode"
            placeholder="97XXX"
            rows="3"
            :state="errors.length > 0 ? false:null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col md="12">
      <b-form-group
        :label="setLabel('Main Menu Description', i)"
        :label-for="setIdName('menu-description', i)"
      >
        <validation-provider
          #default="{ errors }"
          name="menu-description"
          rules="required|max130"
        >
          <b-form-textarea
            :id="setIdName('menu-description', i)"
            v-model="content.sub_menu[i].description"
            placeholder="Write product description"
            rows="3"
            :state="errors.length > 0 ? false:null"
            @keyup="countdown(i)"
            @input="countdown(i)"
          />
          <small class="text-danger">{{ errors[0] }}</small>
          <b-form-text
            :ref="`menuDesc-${i}`"
            class="small"
          >
            Remaining Char: {{ remainingCount[i] }} Char</b-form-text>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col md="12">
      <b-form-group
        label="Total Set Sub Menu"
        label-size="sm"
      >
        <validation-provider
          #default="{ errors }"
          name="total-submenu"
          rules="required"
        >
          <v-select
            id="total-submenu"
            v-model="content.total_sub"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="listSub"
            :reduce="text => text.value"
            label="text"
            :state="errors.length > 0 ? false:null"
            @input="onChangeTotal"
          />
          <small class="text-danger">{{ errors[0] }}</small>
          <b-form-text
            class="small"
          >
            {{ content.total_sub }} out of 2</b-form-text>
        </validation-provider>
      </b-form-group>
    </b-col>
    <div
      v-for="(sub, idx) in submenuTotal"
      :key="idx+1"
      class="d-flex flex-wrap w-100"
    >
      <b-col
        md="6"
      >
        <b-form-group
          :label="setLabel('Sub Menu Name', idx + 1, '(Your Product Name)')"
          :label-for="setIdName('sub-menu-name', idx + 1)"
        >
          <validation-provider
            #default="{ errors }"
            :name="setIdName('sub-menu-name', idx + 1)"
            rules="required|max16"
          >
            <b-form-input
              :id="setIdName('sub-menu-name', idx + 1)"
              v-model="content.sub_menu[idx + 1].name"
              placeholder="Write product short script"
              rows="3"
              :state="errors.length > 0 ? false:null"
              @keyup="countdownMenu(idx+1)"
              @input="countdownMenu(idx+1)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
            <b-form-text
              :ref="`menuName-${idx+1}`"
              class="small"
            >
              Remaining Char: {{ remainingMenuCount[idx+1] }} Char</b-form-text>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col
        v-if="method === 3"
        md="4"
      >
        <b-form-group
          :label="setLabel('Product Registry Key', idx + 1)"
          :label-for="setIdName('product-registry-key', idx + 1)"
        >
          <validation-provider
            #default="{ errors }"
            :name="setIdName('product-registry-key', idx + 1)"
            rules="required"
          >
            <b-form-input
              :id="setIdName('product-registry-key', idx + 1)"
              v-model="content.sub_menu[idx + 1].product_registry_key"
              placeholder="Type your product registry key"
              rows="3"
              :state="errors.length > 0 ? false:null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col
        v-if="method === 3"
        md="2"
      >
        <b-form-group
          :label="setLabel('Shortcode', idx + 1)"
          :label-for="setIdName('shortcode', idx + 1)"
        >
          <validation-provider
            #default="{ errors }"
            :name="setIdName('shortcode', idx + 1)"
            rules="required|regex:^([0-9]+)$"
          >
            <b-form-input
              :id="setIdName('shortcode', idx + 1)"
              v-model="content.sub_menu[idx + 1].shortcode"
              placeholder="97XXX"
              rows="3"
              :state="errors.length > 0 ? false:null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          :label="setLabel('Menu Description', idx + 1)"
          :label-for="setIdName('menu-description', idx + 1)"
        >
          <validation-provider
            #default="{ errors }"
            :name="setIdName('menu-description', idx + 1)"
            rules="required|max130"
          >
            <b-form-textarea
              :id="setIdName('menu-description', idx + 1)"
              v-model="content.sub_menu[idx + 1].description"
              placeholder="Write product description"
              rows="3"
              :state="errors.length > 0 ? false:null"
              @keyup="countdown(idx+1)"
              @input="countdown(idx+1)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
            <b-form-text
              :ref="`menuDesc-${idx+1}`"
              class="small"
            >
              Remaining Char: {{ remainingCount[idx+1] }} Char</b-form-text>
          </validation-provider>
        </b-form-group>
      </b-col>
    </div>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormText,
  BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, extend } from 'vee-validate'

extend('max16', value => {
  if (value.length <= 16) {
    return true
  }
  return 'The {_field_} field must be max 16 char'
})

extend('max130', value => {
  if (value.length <= 130) {
    return true
  }
  return 'The {_field_} field must be max 130 char'
})

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormText,
    BFormTextarea,
    ValidationProvider,
    vSelect,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    method: Number,
  },
  data() {
    return {
      content: {
        total_sub: 0,
        menu_name: '',
        sub_menu: [
          {
            name: '',
            description: '',
            action_link: '',
            product_registry_key: '',
            shortcode: '',
          },
        ],
      },
      submenuTotal: [],
      listSub: [],
      i: 0,
      maxCount: 130,
      remainingCount: [130, 130, 130],
      maxMenuCount: 16,
      remainingMenuCount: [16, 16, 16],
    }
  },
  beforeMount() {
    this.listTotalSub()
  },
  mounted() {
    this.onChangeTotal(0)
  },
  // updated() {
  //   this.remainingMenuCount.forEach((el, id) => {
  //     this.setCountText(el, id)
  //   })
  // },
  methods: {
    setContent() {
      this.$store.state.campaign.formCampaign.content = this.content
    },
    setLabel(text, val, form = null) {
      if (val === 0) {
        return `${text}`
      }

      if (form !== null) {
        return `${text}  ${val} ${form}`
      }

      return `${text} ${val}`
    },
    setIdName(text, val) {
      return `${text}-${val}`
    },
    listTotalSub() {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < 3; i++) {
        this.listSub[i] = {
          text: `${i}`,
          value: i,
        }
      }
    },
    onChangeTotal(val) {
      let subMe = this.content.sub_menu[0]
      this.content.sub_menu = []
      this.content.sub_menu.push(subMe)
      if (val === 0) {
        this.submenuTotal = []
        // console.log(val, this.content.sub_menu)
      }
      if (val !== 0) {
        // console.log(val, this.submenuTotal)
        this.submenuTotal = [...Array(val).keys()].map(i => this.submenuTotal[i + 1] || {})
        // eslint-disable-next-line no-plusplus
        for (let i = 1; i <= val; i++) {
          let obj = {}

          obj.name = ''
          obj.description = ''
          obj.action_link = ''
          obj.product_registry_key = ''
          obj.shortcode = ''
          this.content.sub_menu.push(obj)
        }
      }
    },
    setDataSubmenu() {
      this.content.sub_menu.push(this.item)
    },
    countdown(ix) {
      this.remainingCount[ix] = Math.max(0, this.maxCount - this.content.sub_menu[ix].description.length)
      this.setCountText(this.remainingCount[ix], ix)
    },
    countdownMenu(ix) {
      this.remainingMenuCount[ix] = Math.max(0, this.maxMenuCount - this.content.sub_menu[ix].name.length)
      // console.log(this.remainingMenuCount[ix], ix)
      this.setCountTextMenu(this.remainingMenuCount[ix], ix)
    },
    setCountText(text, idx) {
      let textName = `menuDesc-${idx}`
      // eslint-disable-next-line no-unused-expressions
      this.$refs[textName].textContent === `Remaining Char: ${text} Char`
      // console.log(textName)
    },
    setCountTextMenu(text, idx) {
      let textName = `menuName-${idx}`
      // eslint-disable-next-line no-unused-expressions
      this.$refs[textName].textContent === `Remaining Char: ${text} Char`
      // console.log(textName)
    },
  },
}
</script>

<style scoped>
</style>
